// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {OpAck} from './op-ack.js'
import {Uuid} from './uuid.js'

export class NoteMutationResponse {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): NoteMutationResponse {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsNoteMutationResponse(bb: flatbuffers.ByteBuffer, obj?: NoteMutationResponse): NoteMutationResponse {
    return (obj || new NoteMutationResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsNoteMutationResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: NoteMutationResponse
  ): NoteMutationResponse {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new NoteMutationResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  noteId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Uuid()).__init(this.bb_pos + offset, this.bb!) : null
  }

  acks(index: number, obj?: OpAck): OpAck | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset
      ? (obj || new OpAck()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!)
      : null
  }

  acksLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  static startNoteMutationResponse(builder: flatbuffers.Builder) {
    builder.startObject(2)
  }

  static addNoteId(builder: flatbuffers.Builder, noteIdOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, noteIdOffset, 0)
  }

  static addAcks(builder: flatbuffers.Builder, acksOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, acksOffset, 0)
  }

  static createAcksVector(builder: flatbuffers.Builder, data: flatbuffers.Offset[]): flatbuffers.Offset {
    builder.startVector(4, data.length, 4)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!)
    }
    return builder.endVector()
  }

  static startAcksVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4)
  }

  static endNoteMutationResponse(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // note_id
    builder.requiredField(offset, 6) // acks
    return offset
  }

  static createNoteMutationResponse(
    builder: flatbuffers.Builder,
    noteIdOffset: flatbuffers.Offset,
    acksOffset: flatbuffers.Offset
  ): flatbuffers.Offset {
    NoteMutationResponse.startNoteMutationResponse(builder)
    NoteMutationResponse.addNoteId(builder, noteIdOffset)
    NoteMutationResponse.addAcks(builder, acksOffset)
    return NoteMutationResponse.endNoteMutationResponse(builder)
  }
}
